import React, { useEffect } from 'react'

import { useEditEventSeriesContext } from '../EditEventSeriesProvider'
import EventsList from './EventsList'
import Toolbar from './Toolbar'
import { useTranslation } from 'react-i18next'

export default function SimilarEventsTab() {
  const { similarEvents, clearSelection } = useEditEventSeriesContext()
  const { t } = useTranslation()

  useEffect(() => {
    return () => {
      clearSelection()
    }
  }, [clearSelection])

  return (
    <div>
      <Toolbar events={similarEvents} className='mt-4 mb-4' isDisabled={similarEvents.length === 0}/>

      <EventsList events={similarEvents} isIncluded={false} emptyMessage={t('Event.editEventSeriesModal.noSimilarEvents')} />
    </div>
  )
}